import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LinkComponent } from '../link/link.component';
import { COPY_RIGHT_INFO } from './footer-copyright.constants';

@Component({
  selector: 'ps-footer-copyright',
  imports: [LinkComponent],
  templateUrl: './footer-copyright.component.html',
  styleUrl: './footer-copyright.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterCopyrightComponent {
  protected readonly year: number = new Date().getFullYear();
  protected readonly companyName: string = COPY_RIGHT_INFO.COMPANY_NAME;
  protected readonly contactRef: string = COPY_RIGHT_INFO.CONTACT.REF;
  protected readonly contactLabel: string = COPY_RIGHT_INFO.CONTACT.LABEL;
}
